import { createFileRoute } from "@tanstack/react-router";
import AdminKiosk from "@/pages/admin/AdminKiosk";

export const Route = createFileRoute("/_adminLayout/admin/kiosk")({
  component: AdminKiosk,
});
